import React from 'react';
import MealSlot from './MealSlot';

function CalendarDay({ day, meals }) {
  return (
    <div className="calendar-day" style={{ backgroundColor: 'white', borderRadius: '10px', padding: '15px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderTop: '4px solid #3498db', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <h3 style={{ marginTop: 0, marginBottom: '5px', color: '#2980b9', textAlign: 'center', textTransform: 'uppercase', fontSize: '1.1rem', letterSpacing: '1px' }}>{day}</h3>
      <MealSlot day={day} meal="breakfast" recipes={meals.breakfast} />
      <MealSlot day={day} meal="lunch" recipes={meals.lunch} />
      <MealSlot day={day} meal="dinner" recipes={meals.dinner} />
      <MealSlot day={day} meal="snacks" recipes={meals.snacks} />
    </div>
  );
}

export default CalendarDay;
